import { useEffect, useState } from "react";
import styles from "./fonada.module.css";
import { showBasicAlert } from "../../../../core/common/useAlert";
import CommonSelect from "../../../../core/common/commonSelect";
import api from "../../../../services/api";
import Loader from "../../../../core/common/loader";
import { Link } from "react-router-dom";
import ViewTemplatesModal from "./ViewTemplatesModal";

const Fonada = () => {
  const signature = localStorage.getItem("signature");
  const [provider, setProvider] = useState("Fonada");
  const [apikey, setApiKey] = useState("");
  const [leadMessage, setLeadMessage] = useState("");
  const [campaignName, setCampaignName] = useState("");
  const [method, setMethod] = useState("POST");
  const [url, setUrl] = useState(
    "https://backend.api-wa.co/campaign/fonada/api/v2/"
  );
  const [isLoading, setIsLoading] = useState(false);
  const [showTemplatesModal, setShowTemplatesModal] = useState(false);
  const [templateType, setTemplateType] = useState("");
  const [companyList, setCompanyList] = useState<any[]>([]);
  const [campaignData, setCampaignData] = useState<any[]>([]);
  const [selectedCompany, setSelectedCompany] = useState({
    companyId: "",
    companyName: "Select Company",
    companyType: "",
  });

  const [category, setCategory] = useState("");
  const [todoType, setTodoType] = useState("");
  const [leadFormList, setLeadForms] = useState<any[]>([]);

  const [pipelineOptions, setPipelineOptions] = useState<string[]>([]);

  var initialFormDataChooseCompany = {
    pipeline_id: "",
    form_name: "",
  };
  const [formDataCompanyChoose, setformDataCompanyChoose] = useState(
    initialFormDataChooseCompany
  );

  const fetchCompanyList = async () => {
    setIsLoading(true);
    try {
      const response = await api.post("userService/getAllCompanyList", {
        signature,
      });
      setCompanyList(response.data.data.data);

      const newCompany = {
        companyId: response.data.data.data[0].id,
        companyName: response.data.data.data[0].name,
        companyType: response.data.data.data[0].type,
      };

      setSelectedCompany(newCompany);

      const [dataResponse, getAllLeadFormsByCompany] = await Promise.all([
        api.post("whatsappService/getFonadaProvider", {
          signature,
          companyId: newCompany.companyId,
          companyType: newCompany.companyType,
          provider,
        }),
        api.post("leadService/getLeadFormsByCompany", {
          signature,
          company_id: parseInt(newCompany.companyId),
          company_type: newCompany.companyType,
        }),
      ]);
      setCampaignData(dataResponse.data.data);
      setLeadForms(getAllLeadFormsByCompany.data.data.data);
      handleFormChange({
        value: getAllLeadFormsByCompany.data.data.data?.[0]?.pipeline_id,
        label: getAllLeadFormsByCompany.data.data.data?.[0]?.LeadFormName,
      });
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };

  const formChoose = [
    ...leadFormList?.map((form: any) => ({
      value: form.pipeline_id,
      label: form.LeadFormName,
    })),
  ];

  useEffect(() => {
    fetchCompanyList();
  }, []);

  useEffect(() => {
    if (formDataCompanyChoose?.pipeline_id != "") {
      handleFormChange({
        value: formDataCompanyChoose?.pipeline_id,
        label: formDataCompanyChoose?.form_name,
      });
    }
  }, [category]);

  const handleCompanyChange = async (selectedOption: any) => {
    if (!selectedOption) return;
    setIsLoading(true);
    const newCompany = {
      companyId: selectedOption.value,
      companyName: selectedOption.label.split("-")[0].trim(),
      companyType: selectedOption.label.split("-")[1].trim(),
    };

    setSelectedCompany(newCompany);

    const [dataResponse, getAllLeadFormsByCompany] = await Promise.all([
      api.post("whatsappService/getFonadaProvider", {
        signature,
        companyId: newCompany.companyId,
        companyType: newCompany.companyType,
        provider,
      }),
      api.post("leadService/getLeadFormsByCompany", {
        signature,
        company_id: parseInt(newCompany.companyId),
        company_type: newCompany.companyType,
      }),
    ]);
    setCampaignData(dataResponse.data.data || []);
    setLeadForms(getAllLeadFormsByCompany.data.data.data || []);
    handleFormChange({
      value: getAllLeadFormsByCompany.data.data.data?.[0]?.pipeline_id,
      label: getAllLeadFormsByCompany.data.data.data?.[0]?.LeadFormName,
    });
    setIsLoading(false);
  };

  const handleSubmit = async () => {
    const data = {
      signature,
      provider,
      method,
      url,
      category,
      templateType,
      apikey,
      campaignName,
      leadMessage,
      companyId: selectedCompany.companyId,
      companyType: selectedCompany.companyType,
    };

    if (apikey == "") {
      showBasicAlert("Please enter API key.");
      return;
    }
    if (campaignName == "") {
      showBasicAlert("Please enter Campaign Name.");
      return;
    }

    var response = await api.post("whatsappService/addFonadaProvider", data);
    if (response.data.message[0].status) {
      setApiKey("");
      setCampaignName("");
    }
    showBasicAlert(response.data.message[0].msg);
  };

  const renderTemplateNote = () => {
    if (
      templateType === "todo-alerts-new" ||
      templateType === "todo-alerts-followers" ||
      templateType === "todo-alerts-reminder" ||
      templateType === "todo-alerts-overdue" ||
      templateType === "todo-alerts-comments" ||
      templateType === "todo-alerts-stage"
    ) {
      return (
        <div className={styles.whatsappConfigNote}>
          <h5>Template Registration – ToDo Alerts</h5>
          <ol style={{ marginTop: "10px" }}>
            <li>Step 1: Login to your Fonada account</li>
            <li>Step 2: Go to Templates → Create New</li>
            <li>
              Step 3: Use below parameters in your message:
              <ul>
                <li>
                  <code>{"{{assignedTo}}"}</code>
                </li>
                <li>
                  <code>{"{{taskName}}"}</code>
                </li>
                {templateType != "todo-alerts-comments" &&
                  templateType != "todo-alerts-stage" && (
                    <li>
                      <code>{"{{deadline}}"}</code>
                    </li>
                  )}

                {templateType === "todo-alerts-stage" && (
                  <li>
                    <code>{"{{oldStage}}"}</code>
                  </li>
                )}
                {templateType === "todo-alerts-stage" && (
                  <li>
                    <code>{"{{newStage}}"}</code>
                  </li>
                )}
                {templateType === "todo-alerts-stage" && (
                  <li>
                    <code>{"{{changedBy}}"}</code>
                  </li>
                )}
                <li>
                  <code>{"{{assignedBy}}"}</code>
                </li>
              </ul>
              <p style={{ marginTop: "20px" }}>
                Example:{" "}
                <i>
                  {templateType === "todo-alerts-new" &&
                    "Hi {{assignedTo}}, You have been assigned the task {{taskName}},Due by {{deadline}}.Assigned by {{assignedBy}}"}
                  {templateType === "todo-alerts-followers" &&
                    "Hi {{follower}}, You have been assigned as the supervisor for the task {{taskName}}, assigned to {{assignedTo}}, due by {{deadline}}. Assigned by {{assignedBy}}."}
                  {templateType === "todo-alerts-reminder" &&
                    "Reminder: Hi {{assignedTo}}, your task {{taskName}} is due by {{deadline}}. Please ensure it's completed. Assigned by {{assignedBy}}."}
                  {templateType === "todo-alerts-overdue" &&
                    "Alert: Hi {{assignedTo}}, your task {{taskName}} was due by {{deadline}} and is now overdue. Kindly follow up. Assigned by {{assignedBy}}."}
                  {templateType === "todo-alerts-comments" &&
                    "Hi {{assignedTo}}, a new comment has been added to your task {{taskName}}. Please check and respond. Assigned by {{assignedBy}}."}
                  {templateType === "todo-alerts-stage" &&
                    "Hi {{assignedTo}}, the stage of your task {{taskName}} has been updated from {{oldStage}} to {{newStage}}. Assigned by {{assignedBy}}."}
                </i>
              </p>
              <p>
                <strong>Important:</strong> While you’re free to modify the
                wording of your message, the{" "}
                <strong>sequence of parameters</strong> (like{" "}
                <code>{"{assignedTo}"}</code>, <code>{"{assignedBy}"}</code>,
                etc.) must remain in the same orderas shown above.
              </p>
            </li>
          </ol>
        </div>
      );
    } else if (category === "leads") {
      return (
        <div className={styles.whatsappConfigNote}>
          <h5>Template Registration – Lead Alerts</h5>
          <ol>
            <li>Step 1: Login to your Fonada account</li>
            <li>Step 2: Navigate to Message Templates</li>
            <li>
              Step 3: Include <code>{"{{leadName}}"}</code>,{" "}
              <code>{"{{message}}"}</code>, <code>{"{{managedBy}}"}</code>.
            </li>
            <li>
              Ensure placeholders match exactly between Fonada and our system.
            </li>
          </ol>
        </div>
      );
    }
    return (
      <div className={styles.whatsappConfigNote}>
        <h4>How to Integrate Your WhatsApp API</h4>
        <ol>
          <li>
            <strong>Step 1:</strong> Ensure you have an active WhatsApp Business
            API account with your Fonada provider.
          </li>
          <li>
            <strong>Step 2:</strong> Copy your API Key from your provider’s
            dashboard.
          </li>
          <li>
            <strong>Step 3:</strong> Choose the correct HTTP Method (GET or
            POST) based on your provider’s documentation.
          </li>
          <li>
            <strong>Step 4:</strong> If headers are required (e.g.,{" "}
            <code>Authorization</code>, <code>Content-Type</code>), add them
            using the "Headers" tab.
          </li>
          <li>
            <strong>Step 5:</strong> Ensure your message content uses dynamic
            placeholders like <code>$$param</code> . These will be replaced
            automatically when sending.
          </li>
        </ol>
        <p>
          ✅ <strong>Tip:</strong> Always test with a valid number and a
          registered WhatsApp template.
        </p>
        <p>
          Need help? Refer to your provider’s documentation or contact your
          support team for setup credentials.
        </p>
      </div>
    );
  };

  const handleFormChange = async (selectedOption: any) => {
    if (selectedOption.value == undefined) {
      const newFormData = {
        pipeline_id: "",
        form_name: "",
      };

      setformDataCompanyChoose((prev: any) => ({
        ...prev,
        ...newFormData,
      }));
      setPipelineOptions([]);
      return;
    }
    const newFormData = {
      pipeline_id: selectedOption.value,
      form_name: selectedOption.label,
    };

    setformDataCompanyChoose((prev: any) => ({
      ...prev,
      ...newFormData,
    }));

    var result = await api.post("leadService/getAllPipelinesById", {
      signature,
      id: newFormData.pipeline_id,
    });
    const filteredDataPipeline = result.data.data.data;
    setPipelineOptions(filteredDataPipeline[0]?.Stages || []);
  };

  return (
    <>
      {isLoading && <Loader />}
      <div className={styles.whatsappConfigContainer}>
        <Link
          to="#"
          onClick={() => setShowTemplatesModal(true)}
          className="dropdown-item rounded-1"
          style={{ textAlign: "right" }}
        >
          <i className="ti ti-eye me-1" />
          View Registered Templates
        </Link>
        {showTemplatesModal && (
          <ViewTemplatesModal
            open={showTemplatesModal}
            onClose={() => setShowTemplatesModal(false)}
            campaigns={campaignData}
            refresh={fetchCompanyList}
          />
        )}

        <div className={styles.whatsappConfigForm}>
          <div className="me-3 mb-2">
            <label>Company</label>
            <CommonSelect
              options={companyList.map((company) => ({
                value: company.id,
                label: `${company.name} - ${company.type}`,
              }))}
              defaultValue={{
                value: selectedCompany.companyId,
                label: `${selectedCompany.companyName} - ${selectedCompany.companyType}`,
              }}
              onChange={handleCompanyChange}
            />
          </div>
          <div className={styles.formGroup}>
            <label>WhatsApp API Provider</label>
            <input type="text" value={provider} disabled />
          </div>

          <div className={styles.formGroup}>
            <label>URL</label>
            <input type="text" value={url} disabled />
          </div>

          <div className={styles.formGroup}>
            <label>Method</label>
            <select value={method} disabled>
              <option value="POST" selected>
                POST
              </option>
              <option value="GET">GET</option>
            </select>
          </div>

          <div className={styles.formGroup}>
            <label>Campaign Name</label>
            <input
              type="text"
              value={campaignName}
              placeholder="e.g., todo_alerts_campaign (must match Fonada)"
              required
              onChange={(e) => setCampaignName(e.target.value)}
            />
          </div>

          <div className={styles.formGroup}>
            <label>API Key</label>
            <input
              type="text"
              value={apikey}
              placeholder="Enter your API key here"
              required
              onChange={(e) => setApiKey(e.target.value)}
            />
          </div>

          {/* Template type dropdown */}
          <div className={styles.formGroup}>
            <label>Select Category</label>
            <select
              value={category}
              onChange={(e) => {
                setCategory(e.target.value);
                setTodoType("");
                setTemplateType("");
                setPipelineOptions([]);
              }}
            >
              <option value="">-- Select --</option>
              <option value="todo">Todo Alerts</option>
              <option value="leads">Leads Alerts</option>
            </select>

            {category === "todo" && (
              <div className={styles.formGroup} style={{ marginTop: "10px" }}>
                <label>Type</label>
                <select
                  value={templateType}
                  onChange={(e) => setTemplateType(e.target.value)}
                >
                  <option value="">-- Select Type --</option>
                  <option value="todo-alerts-new">For New Todo</option>
                  <option value="todo-alerts-followers">
                    For Todo Followers
                  </option>
                  <option value="todo-alerts-reminder">
                    For Reminder Todo
                  </option>
                  <option value="todo-alerts-overdue">For Overdue Todo</option>
                  <option value="todo-alerts-comments">For Comments</option>
                  <option value="todo-alerts-stage">For Stage Change</option>
                </select>
              </div>
            )}

            {category === "leads" && (
              <>
                <div className={styles.formGroup} style={{ marginTop: "10px" }}>
                  <label>Select Form</label>
                  <CommonSelect
                    className="select"
                    options={formChoose}
                    defaultValue={{
                      value: formDataCompanyChoose.pipeline_id,
                      label: formDataCompanyChoose.form_name,
                    }}
                    onChange={handleFormChange}
                  />
                </div>

                {formChoose.length > 0 && (
                  <div
                    className={styles.formGroup}
                    style={{ marginTop: "10px" }}
                  >
                    <label>Select Pipeline</label>
                    <select onChange={(e) => setTemplateType(e.target.value)}>
                      <option value="">Select Pipeline</option>
                      {pipelineOptions.map((p, idx) => (
                        <option key={idx} value={p}>
                          {p}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {templateType != "" && (
                  <div className={styles.formGroup}>
                    <label>Message</label>
                    <input
                      type="text"
                      value={leadMessage}
                      placeholder={`Enter message when lead in ` + templateType}
                      required
                      onChange={(e) => setLeadMessage(e.target.value)}
                    />
                  </div>
                )}
              </>
            )}
          </div>

          <div className={styles.formActions}>
            <button
              className={`${styles.btn} ${styles.primary}`}
              onClick={handleSubmit}
            >
              Add Provider
            </button>
          </div>
        </div>
        {/* Dynamic note on right */}
        {renderTemplateNote()}
      </div>
    </>
  );
};

export default Fonada;
